// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3159b069","299":"41baec16","453":"1948afd4","667":"a54924f7","859":"e63ac361","977":"739f0ce4"}[chunkId] + ".chunk.js";
};